export class AppError {
  errorNumber!: number;
  message!: string;
  friendlyMessage!: string;
  apiErrorMessage!: string;
}
